import { render, staticRenderFns } from "./FormButtonCheckbox.vue?vue&type=template&id=66025962&scoped=true&"
import script from "./FormButtonCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormButtonCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FormButtonCheckbox.vue?vue&type=style&index=0&id=66025962&prod&scoped=true&lang=css&"
import style1 from "./FormButtonCheckbox.vue?vue&type=style&index=1&id=66025962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66025962",
  null
  
)

export default component.exports